export const API_PROJECTS_FINANCIAL_INCLUSION_SECTION_TRANSLATIONS_FIELDS = [
    'project_first_type.financial_inclusion_section.translations.id',
    'project_first_type.financial_inclusion_section.translations.languages_code',
    'project_first_type.financial_inclusion_section.translations.title',
    'project_first_type.financial_inclusion_section.translations.text',
    'project_first_type.financial_inclusion_section.translations.final_message'
];
